<template>
  <div class="curtomer_wrap" v-if="customerData">
    <el-collapse @change="changeCollspse" v-model="activeName">
      <el-collapse-item name="1">
        <template slot="title">
          <span class="customer_header basic">
            <i></i>
            客户信息
            <em class="openfalg">{{flagTxt}}</em>
          </span>
        </template>
        <section class="customer_main">
          <div>
            <el-row>
              <el-col :span="8">
                <div class="customer_box" :class="isShowTransfer?'activeex':false">
                  <div class="customer_name" :title="customerData.cusName">
                    <el-link
                      :underline="false"
                      type="primary"
                      class="customer_name"
                      @click="onCustomerDetails"
                    >{{customerData.cusName}}</el-link>
                    <el-button
                      v-show="isShowChange"
                      @click="changeCustomer"
                      style="margin-left:20px;"
                      size="mini"
                    >更换</el-button>
                  </div>
                  <div class="customer_grade">
                    <el-rate
                      v-model="starLevel"
                      disabled
                      show-score
                      text-color="#ff9900"
                      score-template="{value}星"
                    ></el-rate>
                    <span>（系数{{customerData.starPoint*100}}%）</span>
                  </div>
                  <div class="customer_pact">
                    <el-row>
                      <el-col :span="12">履行中合同：{{customerData.endCount}}</el-col>
                      <el-col :span="12">已履行合同：{{customerData.ingCount}}</el-col>
                    </el-row>
                  </div>
                  <div class="customer_pact">贸易额：{{customerData.money | toFixed}}</div>
                  <div class="customer_pact">毛利润：{{customerData.rate | toFixed}}</div>
                  <div class="customer_pact">
                    账户余额：{{customerAccountBase.accountBalance | toFixed}}
                    <el-button
                      v-show="isShowTransfer"
                      type="primary"
                      @click="transferCustomer"
                      style="margin-left:20px;"
                      size="mini"
                    >划拨</el-button>
                  </div>
                  <div
                    v-show="isShowTransfer"
                    style="font-size: 12px;color:#D35E5E;margin-top:-5px;"
                  >*贸易额、毛利润数值统计最近3个月的累计值</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="customer_box">
                  <div class="customer_subtitle">账款信息</div>
                  <div class="echarts_box">
                    <v-echarts :cstyle="{height:'155px'}" :options="echartsOption"></v-echarts>
                  </div>
                  <el-row class="customer_dinfo">
                    <el-col :span="12">已到期账款：{{customerAccountBase.accountsDue | toFixed}}</el-col>
                    <el-col :span="12">未到期账款：{{customerAccountBase.accountsOutstanding | toFixed}}</el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <!--     信用模块         -->
                <div class="customer_box customer_boxex">
                  <div class="customer_subtitle">信用模块</div>
                  <div class="p20 alignc">
                    <div class="customer_credit">{{customerData.useCredit | minZero}}</div>
                    <span>可用信用</span>
                  </div>
                  <div class="p20 alignc">
                    <el-row>
                      <el-col :span="8">
                        <div class="sub_credit">{{customerCreditBase.fixedCredit | minZero}}</div>
                        <span>固定信用</span>
                      </el-col>
                      <el-col :span="8">
                        <div class="sub_credit">{{customerCreditBase.tempCredit | minZero}}</div>
                        <span>临时信用</span>
                      </el-col>
                      <el-col :span="8">
                        <div class="sub_credit">{{customerCreditBase.freezCredit | minZero}}</div>
                        <span>冻结信用</span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <!--      联系方式        -->
                <div class="customer_contact customer_box customer_boxex" v-show="false">
                  <div class="customer_subtitle">联系方式</div>
                  <section style="margin-top: 20px;">
                    <el-row>
                      <el-col :span="24">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-lianxiren"></span>
                          <span>{{customerData.ccContacts || '--'}}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-dianhua"></span>
                          <span>{{customerData.ccPhone || '--'}}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-shouji"></span>
                          <span>{{customerData.ccMobile || '--'}}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-dizhi"></span>
                          <span>{{customerData.bizProvince}}{{customerData.bizAddress}}</span>
                        </div>
                      </el-col>
                    </el-row>
                  </section>
                </div>
              </el-col>
            </el-row>
          </div>
        </section>
        <div class="p20">
          <div class="customer_subtitle">联系方式</div>
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="4">
                  <span class="iconfont icon-kehuxinxi-lianxiren"></span>
                  <span>{{customerData.ccContacts || '--'}}</span>
                </el-col>
                <el-col :span="4">
                  <span class="iconfont icon-kehuxinxi-dianhua"></span>
                  <span>{{customerData.ccPhone || '--'}}</span>
                </el-col>
                <el-col :span="4">
                  <span class="iconfont icon-kehuxinxi-shouji"></span>
                  <span>{{customerData.ccMobile || '--'}}</span>
                </el-col>
                <el-col :span="12">
                  <span class="iconfont icon-kehuxinxi-dizhi"></span>
                  <span>{{customerData.bizProvince}}{{customerData.bizAddress}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import vEcharts from '@/components/module/echarts'

export default {
  name: 'customerModule',
  components: {
    vEcharts
  },
  props: {
    // 客户信息
    customerData: {
      type: Object,
      default: () => {}
    },
    isShowChange: {
      type: Boolean,
      default: false
    },
    isShowTransfer: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    minZero (val) {
      return val < 0 ? 0 : val
    }
  },
  watch: {
    customerData (newval) {
      if (!newval) newval = {}
      const customerAccountBase = newval.customerAccountBase || {}
      const accountsReceivable = customerAccountBase.accountsReceivable || 0
      const paymentReceived = customerAccountBase.paymentReceived || 0
      const badDebt = customerAccountBase.badDebt || 0
      const sum = accountsReceivable + paymentReceived + badDebt
      const echartdata = [
        {
          value: accountsReceivable < 0 ? 0 : accountsReceivable,
          sum,
          name: '应收账款',
          itemStyle: {
            color: '#F8D95B'
          }
        },
        {
          value: paymentReceived < 0 ? 0 : paymentReceived,
          sum,
          name: '已收账款'
        },
        {
          value: badDebt < 0 ? 0 : badDebt,
          sum,
          name: '坏账'
        }
      ]
      this.starLevel = (newval.starLevel && parseInt(newval.starLevel.split('星')[0]))
      if (!this.starLevel) {
        this.starLevel = 1
      }
      this.customerCreditBase = newval.customerCreditBase || {}
      this.customerAccountBase = customerAccountBase || {}
      this.$set(this.echartsOption.series[0], 'data', echartdata)
      this.$set(this.echartsOption.legend, 'formatter', (val) => {
        const obj = echartdata.find((item) => item.name === val)
        const value = obj.value
        const data =
          val +
          '  |  ' +
          ((value / obj.sum) * 100 || 0).toFixed(2) +
          '%' +
          '   ' +
          value.toFixed(2)
        return data
      })
      return newval
    }
  },
  data () {
    return {
      starLevel: 0,
      flagTxt: '收起',
      activeName: '1',
      customerCreditBase: {}, // 客户信用
      customerAccountBase: {}, // 客户基本信息
      echartsOption: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: '50%',
          top: 25,
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            lineHeight: 25,
            color: '#4E555B'
          },
          data: ['应收账款', '已收账款', '坏账']
        },
        series: [
          {
            name: '账款信息',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['25%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 0,
                name: '应收账款',
                itemStyle: {
                  color: '#F8D95B'
                }
              },
              {
                value: 0,
                name: '已收账款'
              },
              {
                value: 0,
                name: '坏账'
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    onCustomerDetails () { // 跳转至客户详情页
      this.$router.push({
        name: 'customer/details',
        query: { id: this.customerData.id }
      })
    },
    changeCollspse (val) {
      this.flagTxt = val.length ? '收起' : '展开'
    },
    transferCustomer () {
      this.$router.push({
        name: 'transferEdit',
        query: { id: this.customerData.id }
      })
    },
    changeCustomer () {
      const { customerData } = this
      this.$emit('changeCustomer', customerData)
    }
  }
}
</script>

<style scoped lang="less">
.iconfont {
  color: #3b85ff;
  margin-right: 10px;
}

.p20 {
  .iconfont {
    margin: 0;
  }
}

.alignc {
  text-align: center;

  & > span {
    font-size: 14px;
    font-weight: 400;
  }
}

.sub_credit {
  font-size: 18px;
  color: #4E555B;
  & + span {
    color: #83878A;
    font-size: 14px;
  }
}

.customer_credit {
  font-size: 20px;
  font-weight: bold;
  color: #3b85ff;
  line-height: 24px;
}

.customer_dinfo {
  font-size: 14px;
  color: #83878a;
  text-align: center;
}

.customer_subtitle {
  padding-bottom: 10px;
  font-size: 14px;
  color: #4E555B;
  font-weight: 700;
}

.activeex {
  .customer_pact {
    padding-bottom: 10px;
  }
}

.customer_pact {
  padding-bottom: 15px;
  color: #4E555B;
  font-size: 14px;
}

.customer_name {
  font-size: 18px;
  font-weight: 700;
  color: #276cff;
  line-height: 27px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: 5px;
}

.customer_grade {
  display: flex;
  font-size: 14px;
  color: #83878a;
  align-items: center;
  padding-bottom: 10px;
}

.curtomer_wrap {
  margin-bottom: 20px;
  border-radius: 4px;
  overflow: hidden;
}

.customer_header {
  padding: 0 20px;

  i {
    width: 4px;
    height: 18px;
    line-height: 20px;
    background-color: #276cff;
    display: inline-block;
    margin-right: 12px;
    vertical-align: -3px;
  }
}

.customer_main {
  border-bottom: 1px solid #e9e9e9;
  height: 250px;
}

.customer_box {
  padding: 20px;
  border-right: 1px solid #e9e9e9;
  height: 250px;
  box-sizing: border-box;
}

.customer_boxex {
  border: 0;
}

.openfalg {
  position: absolute;
  right: 60px;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  color: #276cff;
}

/deep/ .el-collapse-item__header,
.el-collapse-item__wrap {
  border-bottom: 1px solid #ebeef5 !important;
}

/deep/ .el-collapse-item__arrow {
  color: #276cff;
}

/deep/ .el-collapse-item__arrow.is-active {
  transform: translateX(-15px) rotate(-90deg);
}

/deep/ .el-collapse-item__arrow {
  transform: translateX(-15px) rotate(90deg);
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
  color: #4E555B;
}
</style>
